export default {
  about_me: 'Про мене',
  relationships: 'Моє відношення',
  requirements: 'Вимоги',
  users: 'Користувачі',
  sign_up: 'Реєстрація',
  footer: 'Футер',
  sign_out: 'Вийти',
  test_assignment: 'Тестове завдання на посаду Frontend розробника',
  kindly_remind: 'Ми ласкаво нагадуємо, що ваше тестове завдання має бути подано як посилання на сховище github / bitbucket. Будьте терплячі, ми розглядаємо та відповідаємо на кожну заявку, яка відповідає мінімальним вимогам. Ми з нетерпінням чекаємо на Вашу реалізацію. Бажаємо успіху!',
  acquainted: 'Давайте познайомимось',
  developer: 'Я крутий frontend розробник',
  slow_experience: 'Коли справжні користувачі мають повільний досвід роботи з мобільними, вони набагато рідше знаходять те, що вони шукають або купують у вас. Для багатьох сайтів це прирівнюється до втрати величезної можливості, особливо коли більше половини відвідувань припинено, якщо на завантаження мобільної сторінки потрібно більше 3 секунд.',
  improve: 'Минулого тижня команди Google Search та Ads оголосили про дві нові ініціативи щодо підвищення швидкості роботи, які допоможуть покращити роботу користувачів у мережі Інтернет.',
  me_and_web: 'Про мої стосунки з веб-розробкою',
  love_html: 'Я закоханий у HTML',
  html: 'Мова для розмітки гіпертексту (HTML) - це стандартна мова розмітки для створення веб-сторінок та веб-додатків.',
  friend_css: 'CSS мій найкращий друг',
  css: 'Каскадні таблиці стилів (CSS) - мова таблиць стилів, яка використовується для опису елементів сторінки, написаних мовою розмітки, як HTML.',
  passion_js: 'JavaScript - моя пристрасть',
  js: 'JavaScript - інтерпретована мова програмування високого рівня. Це мова, яка також характеризується як динамічна, слабо типізована, заснована на прототипі та багатопарадигма.',
  requirements_desc: 'Загальні вимоги до тестового завдання',
  speed: 'Користувачі хочуть швидко знайти відповіді на свої запитання, і дані показують, що люди дійсно переймаються тим, як швидко завантажуються їх сторінки. Пошукова команда оголосила, що швидкість буде сигналом рейтингу для пошукових запитів на робочому столі у 2010 році, а станом на цей місяць (липень 2018 року) швидкість сторінки також буде фактором рейтингу для мобільних пошуків.',
  performance: 'Якщо ви розробник, який працює над сайтом, зараз прийшов час оцінити ефективність роботи за допомогою наших інструментів швидкості. Подумайте, як ефективність впливає на користувацьку роботу ваших сторінок, і подумайте про вимірювання різноманітних показників продуктивності, орієнтованих на користувача в реальному світі.',
  images: 'Ви відправляєте занадто багато JavaScript? Забагато зображень? Зображення та JavaScript - це найважливіший внесок у вагу сторінки, який впливає на час завантаження сторінки на основі даних з архіву HTTP та звіту про досвід користувачів Chrome - наш загальнодоступний набір даних для ключових метрик UX, які переживають користувачі Chrome в реальних умовах.',
  users_block: 'Наші життєрадісні користувачі',
  registration_date: 'Увага! Сортування користувачів за датою реєстрації',
  more_users: 'Більше користувачів',
  nameLabel: 'Ім\'я',
  emailLabel: 'Електронна адреса',
  phoneLabel: 'Мобільний',
  namePlaceholder: 'Ваше ім\'я',
  emailPlaceholder: 'Ваша електронна адреса',
  phonePlaceholder: 'Ваш мобільний',
  uploadLabel: 'Завантажити',
  uploadPlaceholder: 'Завантажте фото',
  enter_fields: 'Якщо ви хочете зареєструвати нового користувача, вам потрібно заповнити всі поля',
  successfully_registered: 'Новий користувач успішно зареєстрований',
  registered_with_error: 'Помилка: Помилка Мережі',
  select_position: 'Вибиріть свій напрямок',
  lawyer_position: 'Юрист',
  content_manager_position: 'Контент менеджер',
  security_position: 'Охоронець',
  designer_position: 'Дизайнер',
  register_title: 'Зареєструйтесь, щоб отримати роботу',
  update_userslist: 'Увага! Після успішної реєстрації та повідомлення про неї оновіть список користувачів у блоці зверху',
  footer_center_links_news: 'Новини',
  footer_center_links_blog: 'Блог',
  footer_center_links_partners: 'Партнери',
  footer_center_links_shop: 'Магазин',
  footer_center_links_overview: 'Огляд',
  footer_center_links_design: 'Дизайн',
  footer_center_links_code: 'Код',
  footer_center_links_collaborate: 'Співпраця',
  footer_center_links_tutorials: 'Підручники',
  footer_center_links_resources: 'Ресурси',
  footer_center_links_guides: 'Посібники',
  footer_center_links_examples: 'Приклади',
  footer_center_links_faq: 'FAQ',
  footer_center_links_terms: 'Стосунки',
  footer_center_links_conditions: 'Умови',
  footer_center_links_help: 'Допомога',
  write_name_error: 'Ви маєте заповнити це поле',
  name_size: 'Ім\'я повинно мати від 2 до 60 літер',
  write_email_error: 'Ви маєте заповнити це поле',
  no_correct_email: 'Ця єлектронна пошта не є коректною',
  write_phone_error: 'Ви маєте заповнити це поле',
  no_correct_phone: 'Введіть номер телефону у форматі +380XXXXXXXXX',
  photo_type_error: 'Фото повинно бути у jpeg або jpg форматі',
  no_correct_size: 'Фото має бути не меньше 5 MB',
  no_correct_width_height: 'Фото має бути не меньше 70 * 70',
  select_error: 'Ви маєте вибрати свій напрямок'
}